// extracted by mini-css-extract-plugin
export var buttonContainer = "custom-popup-module--buttonContainer--6a562";
export var closeButton = "custom-popup-module--closeButton--41b40";
export var closeContainer = "custom-popup-module--closeContainer--88a94";
export var content = "custom-popup-module--content--74a07";
export var link = "custom-popup-module--link--e8c34";
export var linkContainer = "custom-popup-module--linkContainer--77abe";
export var root = "custom-popup-module--root--7aaf6";
export var show = "custom-popup-module--show--ac60f";
export var text = "custom-popup-module--text--bfdd5";